export default {"src":"/hedera/_next/static/media/hederaDark.34595529.svg","height":56,"width":56};